// Всё, что в сеансе, — внутри каркаса. Нет сеанса — вход с возвратом сюда же (next).
// Нет ни одной роли — экран «Нет доступа» с ФИО администраторов, кодом и номером операции
// ответа auth.me (spec, сценарий 2.1; T058). Пока сервис узнаёт, кто вошёл, — заглушка каркаса
// (T131): не пустой холст. 020 (T031): пользователь без ролей установки, который читает протоколы
// по общему доступу или роли в протоколе (приглашённый сотрудник), — обычный каркас и главная.
import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { isApiError } from '../api/client.ts';
import { ErrorScreen } from '../app/ErrorScreens.tsx';
import { AppShell } from '../shell/AppShell.tsx';
import { NoAccessScreen, noRolesView, sessionOnly } from '../shell/ForbiddenScreen.tsx';
import { ShellSkeleton } from '../shell/ShellSkeleton.tsx';
import { isForbiddenCode } from '../shell/permissions.ts';
import { meQuery, useMe } from '../shell/session.ts';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery());
    } catch (error) {
      if (isApiError(error, 'AUTH-004')) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error -- так TanStack Router перенаправляет
        throw redirect({ to: '/login', search: { next: location.href } });
      }
      throw error;
    }
  },
  component: AppGate,
  errorComponent: AppError,
  pendingComponent: ShellSkeleton,
});

function AppGate() {
  const me = useMe();
  if (sessionOnly(me)) {
    // Номер операции — ответа auth.me, по которому видно, что ролей нет (T058).
    const view = noRolesView(me.admins.map((admin) => admin.fullName));
    return <NoAccessScreen text={view.text} code={view.code} operation={view.operation} />;
  }
  return <AppShell />;
}

/** Сервер не открыл сеанс без ролей — тот же экран с причиной и кодом сервера. */
function AppError(props: ErrorComponentProps) {
  const { error } = props;
  if (isApiError(error) && isForbiddenCode(error.code)) {
    return (
      <NoAccessScreen
        text={`${error.message}. ${error.nextStep}`}
        code={error.code}
        operation={error.operation}
      />
    );
  }
  return <ErrorScreen {...props} />;
}
